import { api } from './api'

const enhancedApi = api.enhanceEndpoints({
  addTagTypes: [
    'ticketProviderTicketFilter',
  ],
})

const extendedApi = enhancedApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchTicketProviderTicketFilters: builder.query({
      query: (params) => {
        return ({
          url: `/admin/ticket_providers/${params.ticketProviderId}/user_filters`,
          params: {
            ...(params.providerTicketBoardId && { providerTicketBoardId: params.providerTicketBoardId }),
          },
        })
      },
      providesTags: (result) => [{ type: 'ticketProviderTicketFilter', id: 'LIST' }],
    }),

    createTicketProviderTicketFilter: builder.mutation({
      query: ({ ticketProviderId, params }) => ({
        url: `/admin/ticket_providers/${ticketProviderId}/user_filters`,
        method: 'POST',
        body: {
          params: params,
        },
      }),
      invalidatesTags: ['ticketProviderTicketFilter'],
    }),

    updateTicketProviderTicketFilter: builder.mutation({
      query: ({ ticketProviderId, ticketFilterId, params }) => ({
        url: `/admin/ticket_providers/${ticketProviderId}/user_filters/${ticketFilterId}`,
        method: 'PATCH',
        body: {
          params: params,
        },
      }),
      invalidatesTags: (result, error, args) => [
        'ticketProviderTicketFilter',
        {
          type: 'ticketProviderTicket',
          id: `TICKET_FILTER_ID_${args.ticketFilterId}`,
        },
      ],
    }),

    removeTicketProviderTicketFilter: builder.mutation({
      query: ({ ticketProviderId, ticketFilterId }) => ({
        url: `/admin/ticket_providers/${ticketProviderId}/user_filters/${ticketFilterId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ticketProviderTicketFilter'],
    }),

    fetchTicketProviderTicketFilterFields: builder.query({
      query: ({ ticketProviderId }) => {
        return ({
          url: `/admin/ticket_providers/${ticketProviderId}/user_filters/filter_fields`,
        })
      },
    }),
  }),
  overrideExisting: false,
})

export const {
  useFetchTicketProviderTicketFiltersQuery,
  useCreateTicketProviderTicketFilterMutation,
  useUpdateTicketProviderTicketFilterMutation,
  useRemoveTicketProviderTicketFilterMutation,
  useFetchTicketProviderTicketFilterFieldsQuery,
} = extendedApi

export const {
  fetchTicketProviderTicketFilters,
} = extendedApi.endpoints
